import cx from 'classnames';
import styles from './index.module.scss';
/**
 * @typedef {0 | 100 | 200 | 300 | 400 | 500| 600 | 700 | 800 | 900 } zIndex
 *
 * @param zIndex {zIndex}
 * @returns - [className]
 *
 * @example
 * const [zIndexClassName] = getZIndex(100);
 */

var getZIndex = function getZIndex(zIndex) {
  var _cx;

  return [cx((_cx = {}, _cx[styles.zIndex0] = zIndex === 0, _cx[styles.zIndex100] = zIndex === 100, _cx[styles.zIndex200] = zIndex === 200, _cx[styles.zIndex300] = zIndex === 300, _cx[styles.zIndex400] = zIndex === 400, _cx[styles.zIndex500] = zIndex === 500, _cx[styles.zIndex600] = zIndex === 600, _cx[styles.zIndex700] = zIndex === 700, _cx[styles.zIndex800] = zIndex === 800, _cx[styles.zIndex900] = zIndex === 900, _cx))];
};

export default getZIndex;